import { useMemo } from "react";
import _ from "underscore";
import { useAtom } from "jotai";
import { drawersInURLAtom } from "../atoms/GlobalAtoms";
import { useSearchParams } from "react-router-dom";

/**
 * Manages updating the URL query params for open ViewRecordDrawers.
 */
const useUpdateDrawerQueryParams = () => {
  // One drawer per view.
  const [drawersInURL, setDrawersInURL] = useAtom(drawersInURLAtom);
  const [search, setSearch] = useSearchParams();

  const updateQueryParams = useMemo(
    () =>
      ({ module, viewID, recordID, action = "push", tab = null }: any) => {
        if (!viewID) return;

        const drawers = search.get("open");

        let drawersObject = [];

        if (drawers) {
          try {
            const parsed = JSON.parse(drawers);

            if (parsed?.length) {
              drawersObject = parsed;
            }
          } catch (e) {}
        }

        if (action === "push") {
          const idx = _.findIndex(drawersObject, (d) => d.id === recordID);

          // Ensure we aren't pushing a duplicate id/module/tab pair if theres already on at the front.
          if (idx !== 0) {
            if (drawersInURL.includes(viewID)) return;

            setDrawersInURL((prev) => [...prev, viewID]);

            drawersObject.push({
              vID: viewID,
              id: recordID,
              module: { APIName: module?.APIName, Name: module?.Name },
              tab: "Summary",
            });
          }
        } else if (action === "pop") {
          setDrawersInURL((prev) => prev.filter((vID) => vID !== viewID));

          drawersObject = _.filter(drawersObject, (d) => {
            return d?.vID !== viewID && d?.module?.APIName !== module?.APIName;
          });
        } else if (action === "tabchange") {
          const idx = _.findIndex(drawersObject, (d) => {
            return d.vID === viewID && d?.module?.APIName === module?.APIName;
          });

          if (idx >= 0) {
            drawersObject[idx].tab = tab;
          }
        }

        const isClosed = drawersObject?.length === 0;
        let drawerStr = JSON.stringify(drawersObject);

        isClosed ? search.delete("open") : search.set("open", drawerStr);

        if (action === "push") {
          return setSearch(search);
        }

        if (action === "pop") {
          search.delete("brie");
          search.delete("record-chat");
          search.delete("comments");
          search.delete("w");
        }

        setSearch(search, { replace: true });
      },
    [search]
  );

  return { updateQueryParams };
};

export default useUpdateDrawerQueryParams;
